import { DecimalPipe } from '@angular/common';
import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'tickerformatter'
})
export class TickerformatterPipe implements PipeTransform {

  constructor(private decimalPipe: DecimalPipe) { }
  
  transform(value: any, ...args: any[]): any {

    //console.log("value",value);
    if (value == null || value == undefined || value == 0) {
     // console.log("value1",value);
      return "0.00";
    }

    if( typeof(value) === 'string' ) {
      return value;
    }

    return this.decimalPipe.transform(value, ...args);
  }

}
